import React, { useState, useCallback, forwardRef, useImperativeHandle } from 'react';
import { Input } from 'antd';
import debounce from 'lodash/debounce';

const { Search } = Input;

const DebouncedSearchInput = forwardRef(({ data }, ref) => {
  const { search, setSearch, loading, placeholder, customStyle, size = "default" } = data;
  const [inputValue, setInputValue] = useState('');

  const handleSearch = useCallback(
    debounce(value => {
      setSearch(value);
    }, 500),
    []
  );

  const handleClear = () => {
    setSearch('');
    setInputValue('');
  };
  useImperativeHandle(ref, () => ({
    input: {
      setValue: (value) => {
        setInputValue(value);
        setSearch(value);
      }
    }
  }));

  return (
    <Search
      value={inputValue}
      placeholder={placeholder}
      size={size}
      allowClear
      onChange={e => {
        setInputValue(e.target.value);
        handleSearch(e.target.value);
      }}
      onSearch={value => {
        setInputValue(value);
        setSearch(value);
      }}
      onClear={handleClear}
      style={{
        maxWidth: customStyle?.width || 300,
        maxHeight: customStyle?.maxHeight | 40,
        height: customStyle?.height | 50,
      }}
      loading={loading}
      enterButton
    />
  );
});

export default DebouncedSearchInput;